module.exports = __webpack_public_path__ + "img/hide-form-rule.7673b457.svg";